import { getDefaultMemberAvatar } from "./market.js";

const maxMale = 11
const maxFemale = 13

export const getUserAvatarPath = (index = 1, gender = "male") => {

    if (Number.isNaN(index)) {
        console.log('no a number!');
        index = 1
    }

    return `/assets/images/avatars/${gender}/avatar_${index}.jpg`
}

export const getRandomUserAvatarByGender = (gender) => {
    if (!gender || (gender !== 'male' && gender !== 'female')) {
        gender = Math.random() < 0.5 ? 'male' : 'female'
    }
    const maxRange = gender === 'male' ? maxMale : maxFemale
    const randomIndex = Math.floor(Math.random() * (maxRange - 1 + 1) + 1)
    return `/assets/images/avatars/${gender}/avatar_${randomIndex}.jpg`
}

// Display-only avatar for a MEMBER (end-user) record: their own photo, else the current domain's
// configured club logo, else a random stock avatar. #1424 — never persist the return value into a
// member's real imageUrl field (it would falsely satisfy the season-ticket photo requirement and
// print as their ID photo on wallet passes/subscription cards).
//
// Deliberately NOT used in the dashboard end-users table (EndUsersTableRow.jsx): a repeated logo
// across many rows carries no distinguishing information and hurts fast scanning the way per-letter
// initials do not, so that table keeps its original imageUrl-or-initials behavior unchanged.
export const getMemberAvatarSrc = (endUser) => {
    const ownPhoto = endUser?.imageUrl
    if (typeof ownPhoto === 'string' && ownPhoto.trim()) return ownPhoto
    return getDefaultMemberAvatar() || getRandomUserAvatarByGender(endUser?.gender)
}